import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Grid, ListItemIcon, Menu, MenuItem, Rating, Typography } from "@mui/material";
import MoreIcon from "@mui/icons-material/MoreVert";
import { getTrip } from "redux/actions/UserTrip";
import { getCancelReason } from "redux/actions/UserCustomerTrip";
import Loader from "components/loader/Loader";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import CommonLinkModel from "components/commonLinkModal/CommonLinkModal";
import { dateFormate,convertDecimalToTime } from "utils/utils";
import { CancelReason } from "routes/components";
import { tripEnumObject } from "utils/enumObject";
import arrowLeft from "assets/images/ArrowLeft.svg";
import myride from "assets/images/myrideInactive.svg";
import clock from "assets/images/greyClock.svg";
import tag from "assets/images/Tag.svg";
import wallet from "assets/images/Wallet.svg";
import pickup from "assets/images/pickUp.svg";
import drop from "assets/images/drop.svg";
import cancel from "assets/images/cancel.svg";
import share from "assets/images/share.svg";


function MyRideDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get('type');
  const myRideData = useSelector((state) => state.userTrip?.userTrip?.data);
  const shareTripUrl = myRideData?.shareTripUrl;
  const cancelReasonData = useSelector((state) => state?.userCancelReason?.userCancelReason?.data);
  const loader = useSelector((state) => state?.userTrip?.loading);
  useEffect(() => {
    const tripData = {
      id: state?.id,
    };
    dispatch(getTrip(tripData));
  }, [state]);

  useEffect(() =>{
      dispatch(getCancelReason())
  },[])

  useEffect(() => {
    if (myRideData?.actualTravelTime) {
      const time = convertDecimalToTime(myRideData.actualTravelTime);
      setConvertedTime(time);
    }
  }, [myRideData]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openDialog, setOpenDialog] = useState(false);
  const [openLink, setOpenLink] = useState(false);
  const [convertedTime, setConvertedTime] = useState({ hours: 0, minutes: 0 });
  const handleClick = (event,data) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCancelClose = () => {
    setOpenDialog(!openDialog);
  }
  const handleLinkClose = () => {
    setOpenLink(!openLink);
  }
  const handleClose = () => {
    setAnchorEl(null);
  }
  const onHandleClick = () => {
    navigate(`/myride?type=${type}`);
  };
  //className font color 
  const fontColor = (status) =>{
   switch (status) {
    case 'Completed':
      return 'colorGreen'
    case 'Cancelled':
      return 'colorRed'
    case 'onGoing':
      return 'colorGrey'
    case 'Booked':
      return 'colorBlue'
    case 'Accepted':
      return 'colorYellow'
    default:
      break;
   }
  }

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <Grid
          container
          direction="column"
          alignItems="flex-start"
          justifyContent="center"
          className="marginTop"
        >
          <Grid item className="width100 myRideMain">
            <img
              src={arrowLeft}
              alt="arrowLeft"
              className="cursor"
              onClick={onHandleClick}
            />
            <Grid item container direction='row' justifyContent="space-between">
            <Typography className="fontHeading fontMedium colorBlue">
              Your Ride
            </Typography>
           {myRideData?.status !== "Cancelled" && myRideData?.status !== "Completed" && myRideData?.status !== "onGoing" && <Button className='colorPrimary'onClick={(event, index) => handleClick(event,index)}>
              <MoreIcon />
            </Button>}
              <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                  >
                   <MenuItem  onClick={handleCancelClose}>
                      <ListItemIcon>
                        <img src={cancel} alt="cancel"/>
                      </ListItemIcon>
                       Cancel Ride
                    </MenuItem>
                    <MenuItem onClick={handleLinkClose}
                    >
                      <ListItemIcon>
                      <img src={share} alt="share"/>
                      </ListItemIcon>
                      Share Ride
                    </MenuItem>
              </Menu>
            </Grid>
            
            <Grid item container direction="row" justifyContent="space-between">
              <Typography className="font18 colorGrey">
              { dateFormate(myRideData?.scheduledTime, " hh:mm A, dddd MMMM DD YYYY")}
               &nbsp; with {myRideData?.DemandProfile?.name}
              </Typography>
              <Typography
                className={`fontNormal ${fontColor(myRideData?.status)}`}        
              >
                {myRideData?.status}
              </Typography>
            </Grid>
          </Grid>
          {myRideData?.status === "Completed" && myRideData?.tripRouteImage && (
            <Grid item className="width100">
              <img
                src={
                  myRideData?.tripRouteImage ? (
                    myRideData?.tripRouteImage?.url
                  ) : (
                    <CommonNoDataFound />
                  )
                }
                alt="completeTrip"
                className="width100 marginTopBottom25"
              />
              <Typography className="font20 fontMedium">Rate Trip</Typography>
              <Grid item className="width100">
              <Rating name="size-medium" defaultValue={myRideData?.Rating?.rating} />
              </Grid>
            </Grid>
          )}
          <Grid item className=" dashedTopLine1px width100">
            <Typography className="font20 fontMedium colorBlack ">
              Trip Details
            </Typography>
            <Grid
              item
              container
              direction="row"
              justifyContent="space-between"
              className="colorGrey width100 marginTop"
              md={8}
            >
              <Grid item className="justifySpaceBetween">
                <img src={myride} alt="myride" />
                <Typography className="marginLeft10">
                  {myRideData?.actualDistance} km
                </Typography>
              </Grid>

              <Grid item className="justifySpaceBetween">
                <img src={clock} alt="clock" />
                <Typography className="marginLeft10">
                  {convertedTime.hours} hr {convertedTime.minutes} min
                </Typography>
              </Grid>
              <Grid item className="justifySpaceBetween">
                <img src={tag} alt="Tag" />
                <Typography className="marginLeft10">
                  ₹ {myRideData?.price}
                </Typography>
              </Grid>
              {/* TODO for future cash present */}
              {/* <Grid item className="justifySpaceBetween">
                <img src={wallet} alt="wallet" />
                <Typography className="marginLeft10">Cash</Typography>
              </Grid> */}
            </Grid>
            <Grid
              item
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              className="colorBlack marginTop25"
              md={7}
            >
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                className="pb10"
              >
                <Grid item xs={1} className="pickUpItem">
                  <div className="pickUpImg"></div>
                  <img src={pickup} alt="star" className="pickUpPosition" />
                </Grid>
                <Grid item xs={11}>
                  <Typography className="font14 fontNormal">
                    {myRideData?.sourceAddress || 'NA'}
                  </Typography>
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <Grid item xs={1}>
                  <div className="dropImg">
                    <img src={drop} alt="star" />
                  </div>
                </Grid>
                <Grid item xs={11}>
                  <Typography className="font14 fontNormal">
                    {myRideData?.destinationAddress || 'NA'}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {myRideData?.status === 'Cancelled' && (
              <Grid container direction="row"  alignItems="end"> 
              <Grid>
                <Typography className="font14 fontMedium colorBlack marginTop25 marginRight8">
                  Cancellation Details :
                </Typography>
              </Grid>
              <Grid item>
                <Typography className="font16 fontNormal colorGrey marginTop25">
                  {myRideData?.cancelReason || myRideData?.cancellationReason || 'NA'}
                </Typography>
                </Grid>
              </Grid>
            ) }
            {/* TODO for future API functionality implementation */}
            {/* <Grid
              item
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              md={10}
              sm={10}
              xs={10}
              className="mtb20"
            >
              <Grid
                item
                className="tripBtn"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button className="tripBtnStyle">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    className="marginRight10"
                  />
                  Review and fares
                </Button>
              </Grid>
              <Grid
                item
                className="tripBtn"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button className="tripBtnStyle">
                  <img
                    src={mailIcon}
                    alt="infoIcon"
                    className="marginRight10"
                  />
                  Resend email
                </Button>
              </Grid>
              <Grid
                item
                className="tripBtn"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button className="tripBtnStyle">
                  <img
                    src={cloudDownloadIcon}
                    alt="infoIcon"
                    className="marginRight10"
                  />
                  Download PDF
                </Button>
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction="row"
              justifyContent="space-between"
              className="dashedTopLine1px"
            >
              <Grid item>
                <Typography className="font20 fontMedium colorBlack">
                  Get Help
                </Typography>
              </Grid>
              <Grid item>
                <img src={rightIcon} alt="icon" />
              </Grid>
            </Grid> */}
          </Grid>
          {openDialog && <CancelReason
      openDialog={openDialog}
      cancelReasonData={cancelReasonData}
      tripId={state?.id}
      handleClose={handleCancelClose}/>}

      {openLink && <CommonLinkModel open={openLink} handleClose={handleLinkClose} shareTripUrl={shareTripUrl}/>}
        </Grid>
      )}
    </>
  );
}

export default MyRideDetails;
